/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Seo_Api_Routing_MultiInputs */

const en_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You call one endpoint per job with a single key, and AnyAPI routes each request across ${i?.count} sources, falling back automatically when one fails.`)
};

const zh_hans1_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每项任务调用一个接口，只需一个密钥，AnyAPI 会在 ${i?.count} 个数据源之间路由每个请求，某个数据源失败时自动切换。`)
};

const pt_br2_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você chama um endpoint por tarefa com uma única chave, e a AnyAPI distribui cada requisição entre ${i?.count} fontes, com failover automático quando uma falha.`)
};

const es_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llamas a un endpoint por tarea con una sola clave, y AnyAPI enruta cada solicitud entre ${i?.count} fuentes, con respaldo automático cuando una falla.`)
};

const fr_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous appelez un endpoint par tâche avec une seule clé, et AnyAPI route chaque requête sur ${i?.count} sources, avec un basculement automatique quand l’une échoue.`)
};

const de_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du rufst einen Endpoint pro Aufgabe mit einem einzigen Schlüssel auf, und AnyAPI routet jede Anfrage über ${i?.count} Quellen und weicht automatisch aus, wenn eine ausfällt.`)
};

const ru_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы вызываете один эндпоинт на задачу с одним ключом, а AnyAPI направляет каждый запрос по источникам (их ${i?.count}) и автоматически переключается, если один из них отказывает.`)
};

const it_seo_api_routing_multi = /** @type {(inputs: Seo_Api_Routing_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chiami un endpoint per ogni lavoro con una sola chiave, e AnyAPI instrada ogni richiesta su ${i?.count} fonti, passando automaticamente a un'altra quando una fallisce.`)
};

/**
* | output |
* | --- |
* | "You call one endpoint per job with a single key, and AnyAPI routes each request across {count} sources, falling back automatically when one fails." |
*
* @param {Seo_Api_Routing_MultiInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_routing_multi = /** @type {((inputs: Seo_Api_Routing_MultiInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_Routing_MultiInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_routing_multi(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_routing_multi(inputs)
	if (locale === "es") return es_seo_api_routing_multi(inputs)
	if (locale === "fr") return fr_seo_api_routing_multi(inputs)
	if (locale === "de") return de_seo_api_routing_multi(inputs)
	if (locale === "ru") return ru_seo_api_routing_multi(inputs)
	if (locale === "it") return it_seo_api_routing_multi(inputs)
	return en_seo_api_routing_multi(inputs)
});